/**
 * @module components/PreSubmitInfo
 * @description Barrel export for PreSubmitInfo component and validation utilities
 */

export { default as PreSubmitInfo, isSignatureValid } from './pre-submit-info';
